import Application from "../../Application";

export default function() {
    Application.Google.init();
    $(document).on('google-auth-granted', function(){
        Application.Google.listUpcomingEvents();
    });

    $('#signout_button').on('click', function() {
        handleSignoutClick();
    });

    $('#signin_button').on('click', function() {
        handleAuthClick();
    });
}

function handleSignoutClick() {
    const token = gapi.client.getToken();
    if (token !== null) {
        google.accounts.oauth2.revoke(token.access_token);
        Cookies.set("gapi_token", '');
        gapi.client.setToken('');
        $('#signout_button').addClass('d-none');
        $('#calendar').addClass('calendar-no-google');
        $('#calendar').text('Accedi a Google per mostare gli eventi');
        $('#signin_button').removeClass('d-none');
    }
}

function handleAuthClick() {
    tokenClient.callback = async (resp) => {
        if (resp.error !== undefined) {
            throw (resp);
        }

        console.log(resp);

        console.log( gapi.client.getToken());

        Cookies.set("gapi_token", gapi.client.getToken().access_token);

        Application.Google.listUpcomingEvents();

    };
    if (gapi.client.getToken() === null) {
        // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        tokenClient.requestAccessToken({prompt: 'consent'});
    } else {
        // Skip display of account chooser and consent dialog for an existing session.
        tokenClient.requestAccessToken({prompt: ''});
    }
}